import Http from "./Http";
import { DEFAULT_LIMIT_AND_OFFSET } from "./BiomarkersService";


class NotificationsService extends Http {
  static $displayName = "NotificationsService";

  async getNotifications(params = DEFAULT_LIMIT_AND_OFFSET) {
    return await this.get("/hl7/notifications", {
      params,
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    });
  }

  async markNotificationAsRead(notificationId) {
    return await this.patch(`/hl7/notifications/${notificationId}/read`);
  }

  async markAllNotificationsAsRead() {
    return await this.patch("/hl7/notifications/read-all");
  }

  async getNotificationLogs(params = DEFAULT_LIMIT_AND_OFFSET) {
    return await this.get("/notifications/logs", { params });
  }

  async sendCustomNotification(payload) {
    return await this.post("/notifications/mobile/custom", payload);
  }

  async getSystemNotifications(params = {}) {
    return await this.get("/notifications", { params });
  }

  async toggleNotificationStatus(id, payload) {
    return await this.patch(`/notifications/${id}/status`, payload);
  }

  async updateNotification(id, payload) {
    return await this.patch(`/notifications/${id}`, payload);
  }
}

export default NotificationsService;
